function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.54 30.76L6.19 34.51C4.66547 35.0819 3.35175 36.1055 2.42436 37.4438C1.49697 38.7822 1.00005 40.3717 1 42V47H47V42C46.9999 40.3717 46.503 38.7822 45.5756 37.4438C44.6482 36.1055 43.3345 35.0819 41.81 34.51L29.46 30.76",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21 27C21.8406 26.3047 22.9104 25.9481 24 26C25.0896 25.9481 26.1594 26.3047 27 27",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18 17L20 18",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30 17L28 18",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M34 9H14C13.4477 9 13 9.44772 13 10V11C13 11.5523 13.4477 12 14 12H34C34.5523 12 35 11.5523 35 11V10C35 9.44772 34.5523 9 34 9Z",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15 8C15 8 16 1 24 1C32 1 33 8 33 8",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14 13V16C13.4385 16.288 12.9599 16.7148 12.6099 17.2399C12.2598 17.765 12.0499 18.3709 12 19C12.0499 19.6291 12.2598 20.235 12.6099 20.7601C12.9599 21.2852 13.4385 21.712 14 22C14 28 21 33 24 33C27 33 34 28 34 22C34.5615 21.712 35.0401 21.2852 35.3901 20.7601C35.7402 20.235 35.9501 19.6291 36 19C35.9501 18.3709 35.7402 17.765 35.3901 17.2399C35.0401 16.7148 34.5615 16.288 34 16V13",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M14 15C15.2527 14.4015 16.6131 14.0614 18 14C20 14 22 15 24 15C26 15 28 14 30 14C31.3869 14.0614 32.7473 14.4015 34 15V21C32.7343 21.6408 31.3386 21.9829 29.92 22C28 22 26 21 24 21C22 21 20 22 18 22C16.6131 21.9386 15.2527 21.5985 14 21V15Z",
  stroke: "#FFD200",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M1 42H47",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M3 37H45",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgTheft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheft);
export default __webpack_public_path__ + "static/media/theft.283c0e0a.svg";
export { ForwardRef as ReactComponent };